import { Controller } from "@hotwired/stimulus"
import { dedupeByEmail, contactRow, emptyMessage } from "../lib/contact_list"

// Lets the admin see exactly who the compose form is about to send to,
// combining checked contact groups (expanded to their members) and checked
// individual entries/leads, with a live search over the resulting list.
export default class extends Controller {
  static targets = ["groupCheckbox", "checkbox", "count", "list", "search"]

  connect() {
    this.refresh()
  }

  filter() {
    this.refresh()
  }

  refresh() {
    const contacts = []

    this.groupCheckboxTargets.filter((checkbox) => checkbox.checked).forEach((checkbox) => {
      JSON.parse(checkbox.dataset.contacts || "[]").forEach((contact) => contacts.push(contact))
    })

    this.checkboxTargets.filter((checkbox) => checkbox.checked).forEach((checkbox) => {
      contacts.push({ name: checkbox.dataset.name, email: checkbox.dataset.email })
    })

    const unique = dedupeByEmail(contacts)

    this.countTarget.textContent = unique.length

    const query = this.hasSearchTarget ? this.searchTarget.value.trim().toLowerCase() : ""
    const visible = query
      ? unique.filter((c) => `${c.name || ""} ${c.email}`.toLowerCase().includes(query))
      : unique

    if (visible.length === 0) {
      const message = unique.length === 0 ? "No recipients selected yet" : "No matches"
      this.listTarget.replaceChildren(emptyMessage(message))
      return
    }

    this.listTarget.replaceChildren(...visible.map(contactRow))
  }
}
